var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessFlower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_587_8260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6664 12C24.6664 10.374 23.9524 8.84003 22.7414 7.87603C22.8814 6.25403 22.3014 4.66503 21.1514 3.51403C20.0014 2.36503 18.4164 1.78603 16.8744 1.95903C14.8604 -0.596968 10.5094 -0.644968 8.5424 1.92403C6.9184 1.78003 5.3314 2.36303 4.1814 3.51403C3.0324 4.66403 2.4524 6.25403 2.6264 7.79103C0.0704025 9.80503 0.0214025 14.156 2.5914 16.124C2.4514 17.746 3.0314 19.335 4.1814 20.486C5.3314 21.635 6.9184 22.216 8.4584 22.041C10.4724 24.597 14.8234 24.645 16.7904 22.076C18.4104 22.212 20.0004 21.637 21.1514 20.486C22.3004 19.336 22.8804 17.746 22.7064 16.209C23.9524 15.161 24.6664 13.627 24.6664 12.001V12ZM18.2064 10.566L13.4674 15.134C12.3044 16.295 10.4014 16.285 9.2384 15.121L6.9864 13.029C6.5824 12.653 6.5584 12.02 6.9344 11.616C7.3114 11.211 7.9454 11.189 8.3474 11.564L10.6254 13.681C11.0434 14.098 11.6754 14.097 12.0654 13.706L16.8174 9.12503C17.2154 8.74303 17.8484 8.75403 18.2314 9.15103C18.6154 9.54803 18.6034 10.182 18.2064 10.565V10.566Z",
    fill: "#30B03D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_587_8260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.666504)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessFlower);
export default __webpack_public_path__ + "static/media/success_flower.9bf390d411353c37c714e58936d6184d.svg";
export { ForwardRef as ReactComponent };